import React from 'react';
import './Suitcase.css';
import RiddleCard from '../RiddleCard/RiddleCard';
import LcdDisplay from '../LcdDisplay/LcdDisplay';

const MODE_LABELS = {
    0: 'OFF',
    1: 'Mode 1 — Insert Data',
    2: 'Mode 2 — Transmit Data',
    3: 'Mode 3 — Find Control Room',
    4: 'Mode 4',
    5: 'Mode 5 — Drone Data',
};

const Suitcase = ({ id, status }) => {
    const connected = status !== null;
    const {
        mode,
        rfid_present,
        button_pressed,
        data_transmitted,
        drone_data_transmitted,
        language,
        last_played_message,
        display_message,
    } = status ?? {};

    const modeLabel = MODE_LABELS[mode] ?? `Mode ${mode}`;

    const mainDiv = (
        <div className="suitcase-container">
            <div className="suitcase-mode">{modeLabel}</div>
            <LcdDisplay text={display_message} />
            <div className="suitcase-grid">
                <div className={`suitcase-indicator ${rfid_present ? 'active' : 'inactive'}`}>
                    <label>Data card</label>
                    <span>{rfid_present ? 'Present' : 'Absent'}</span>
                </div>
                <div className={`suitcase-indicator ${button_pressed ? 'active' : 'inactive'}`}>
                    <label>Button</label>
                    <span>{button_pressed ? 'Pressed' : 'Released'}</span>
                </div>
            </div>
            <div className="suitcase-footer">
                <span className="suitcase-lang">Lang: {(language || 'EN').toUpperCase()}</span>
                {last_played_message && (
                    <span className="suitcase-last-video">Last video: {last_played_message}</span>
                )}
            </div>
        </div>
    );

    return (
        <RiddleCard
            title={id ? id.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : "Suitcase"}
                mainInfo={mainDiv}
            connected={connected}
            index={0}
            layout="half-size"
        />
    );
};

export default Suitcase;
